import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import DatePicker from 'react-datepicker'
import { GGInput } from '../../../shared/new_components/GGInput'

const CustomTimeInput = ({ value, onClick }) => (
  <div onClick={onClick}>
    <input name='schedule_times[]' className='form-control time-input' type='text' value={value}/>
    <i className='fa-regular fa-chevron-down down-logo' aria-hidden='true' />
  </div>
)

export const GolfHubScheduleItems = ({schedules, setSchedules, timeFormat}) => {
  const handleScheduleData = (value, index) => {
    const tempArr = [ ...schedules ]
    tempArr[index].activity = value

    setSchedules(tempArr)
  }

  const remove = (index) => {
    const tempArr = [ ...schedules ]
    tempArr.splice(index, 1)[0]?.id
    setSchedules(tempArr)
  }

  const swapSchedules = (result) => {
    const tempArr = [ ...schedules ]
    const tempVar = tempArr[ result.source.index ]
    tempArr.splice(result.source.index, 1)
    tempArr.splice(result.destination.index, 0, tempVar)

    setSchedules(tempArr)
  }

  const handleTimeChange = (date, index) => {
    const temp = [ ...schedules ]
    temp[index].time = date

    setSchedules(temp)
  }

  const addSchedule = () => {
    const temp = [ ...schedules ]
    let date
    if (temp.length === 0) {
      date = new Date()
    } else {
      const lastindex = temp.length - 1
      date = temp[lastindex].time
    }
    temp.push({time: date, activity: ''})
    setSchedules(temp)
  }

  schedules.sort((date1, date2) => date1.time - date2.time)

  return (
    <Fragment>
      <DragDropContext onDragEnd={swapSchedules}>
        <Droppable droppableId="droppable">
        {(provided) => (
          <div
          ref={provided.innerRef}
          {...provided.droppableProps}
          className='img-container'>

            {schedules.map((schedule, i) => (
              <Draggable key={'draggable-' + i} draggableId={'draggable-' + i} index={i} >
                {(prov) => (
                  <div
                    className='schedule-sponsor-draggable-container'
                    ref={prov.innerRef}
                    {...prov.draggableProps}
                    {...prov.dragHandleProps}>
                    <i className='fa-regular fa-grip-lines drag-handle-icon add-margin-right-15' aria-hidden='true' />
                    <div className='time-picker-div'>
                      <DatePicker
                        selected={schedules[i].time}
                        onChange={date => handleTimeChange(date, i)}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={15}
                        timeCaption={window.I18n.t('views.golfhub.schedule_time_caption')}
                        dateFormat={timeFormat}
                        timeFormat={timeFormat}
                        customInput={<CustomTimeInput />}
                      />
                    </div>
                    <div className='input_item_div'>
                      <GGInput
                        placeholder={window.I18n.t('views.golfhub.describe_item')}
                        value={schedule.activity}
                        name='schedule_activities[]'
                        onChange={(value) => handleScheduleData(value, i)}
                      />
                    </div>
                    <div
                      className='sponsor-remove-btn add-margin-left-10'
                      onClick={() => remove(i)}
                    >
                      <i className='fa-regular fa-trash-can' aria-hidden='true' />
                    </div>
                  </div>
                )}
              </Draggable>
            ))}
          </div>
        )}
        </Droppable>
      </DragDropContext>
      <div className='upload-image add-margin-top-30' onClick={() => addSchedule()}>
        {window.I18n.t('views.golfhub.add_time_slot')}
      </div>
    </Fragment>
  )
}

CustomTimeInput.propTypes = {
  value: PropTypes.string,
  onClick: PropTypes.func,
}

GolfHubScheduleItems.propTypes = {
  schedules: PropTypes.array,
  setSchedules: PropTypes.func,
  timeFormat: PropTypes.string,
}
